import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';

// components
import WeatherApp from './components/WeatherApp';

// hooks
import { useEffect, useState } from 'react';

// for api
import axios from "axios";

// to get current day
import moment from 'moment';
import 'moment/min/locales';

function App() {

	const [lang, setLang] = useState(localStorage.getItem("i18nextLng") || "ar");

	moment.locale(lang);

	const [date, setDate] = useState(null)

	const [cityTemp, setCityTemp] = useState({
		city: null,
		number: null,
		details: "",
		min: null,
		max: null,
		icon: "",
	});

	const [lat, setLat] = useState(JSON.parse(localStorage.getItem("cityCoords")) ?
		JSON.parse(localStorage.getItem("cityCoords")).currentLat : "24.7136");
		
	const [lon, setLon] = useState(JSON.parse(localStorage.getItem("cityCoords")) ?
		JSON.parse(localStorage.getItem("cityCoords")).currentLon : "46.6753");

	useEffect(() => {

		document.documentElement.lang = lang;
		document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

		setDate(moment().format("MMM Do YYYY"));

		axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&
		lon=${lon}&appid=df2fcbffdf9bfb925fe835ed129e4400&lang=${lang}`,
		)
			.then((response) => {
				let city = response.data.name;
				if (city === "Al ‘Atabah" || city === "العتبة") {
					city = lang === "ar" ? "القاهرة" : "Cairo";
				}
				let number = Math.round(response.data.main.temp - 272.15);
				const details = response.data.weather[0].description;
				let min = Math.round(response.data.main.temp_min - 272.15);
				let max = Math.round(response.data.main.temp_max - 272.15);
				const icon = response.data.weather[0].icon;

				function toArabic() {
					number = number.toLocaleString("ar-EG");
					min = min.toLocaleString("ar-EG");
					max = max.toLocaleString("ar-EG");
				}

				if (lang === "ar") {
					toArabic();
				}

				setCityTemp({ city, number, details, min, max, icon });
			})
			.catch((err) => {
				throw Error(err);
			})
	}, [lang, lat, lon]);

	const theme = createTheme({
		typography: {
			fontFamily: ['changa'],
		},
	});

	return (
		<ThemeProvider theme={theme}>
			<div className="App">
				<CssBaseline />
				<WeatherApp cityTemp={cityTemp} date={date} lang={lang} setLang={setLang} setLat={setLat} setLon={setLon} />
			</div>
		</ThemeProvider>
	);
}

export default App;
